<template>
  <div class="wrapper_promocode-card">
    <div class="card">
      <StickerMarker
        v-if="data.discount"
        :type="isPercent ? 'percent' : isRuble ? 'ruble' : 'sale-text'"
        :text="parsedDiscount"
        :show-graduation="isPercent || isRuble"
        class="p-card__marker"
      />
      <div class="main-content">
        <div class="promo-logo">
          <img
            :src="
              (data.shop_info && data.shop_info.logo) ||
              '/static/images/no-img.svg'
            "
            alt=""
          />
          <DebugInfo
            v-if="debugPanel"
            class="debug-promocode"
            :type="data.type"
            :data="data"
          />
        </div>
        <div class="description-content">
          <div class="content-wrapper">
            <div ref="titleCard" class="title text-subtitle-price-bold">
              {{ data.name }}
            </div>
            <div
              ref="descCard"
              :class="[
                'description text-body-m-book',
                { 'long-desc': longDesc },
              ]"
            >
              <RenderHTML tag-wrapper="span" :seotext="description" />
              <button class="more text-body-m-book" @click.prevent="openModal">
                ...ещё
              </button>
            </div>
          </div>
          <div class="promocodes">
            <PromoLabel v-if="data.type" :type="data.type" />
          </div>
        </div>
      </div>
      <div class="navigation-content">
        <ButtonTape
          :text="data.type === 'promocode' ? 'Показать промокод' : 'Перейти'"
          :promo="data"
          :show-tape="data.type === 'promocode'"
          :order="order"
        />
        <div class="time">
          <div v-if="endDate">Действует до {{ endDate }}</div>
        </div>
      </div>
    </div>
    <p class="advertising-marker l-setting-promocodes-card">
      {{ advertising }}
    </p>
  </div>
  <ModalsModelPromo
    v-if="isShowModelPromo"
    :promo="data"
    @close="isShowModelPromo = false"
  />
</template>

<script setup lang="ts">
import ButtonTape from '~/components/promocodes/button-tape/ButtonTape.vue';
import StickerMarker from '~/components/ui/sticker-marker/StickerMarker.vue';
import DebugInfo from '@/components/debug-info/DebugInfo.vue';
import { useParseDiscount } from '~/composition/useParseDiscount';
import PromoLabel from '~/components/ui/promo-label/PromoLabel.vue';
import { useGlobalStore } from '~/stores/global';
import RenderHTML from '~/components/ui/RenderHTML.vue';

const ModalsModelPromo = defineAsyncComponent(
  () => import('~/components/modals/model-promo/model-promo.vue')
);

const props = defineProps({
  data: {
    type: Object as () => any,
    required: true,
  },
  order: {
    type: Number,
    default: 0,
  },
});
const globalStore = useGlobalStore();
const endDate = props.data.end
  ? new Date(+props.data.end * 1000).toLocaleDateString('ru')
  : '';
const titleCard = ref<HTMLElement>();
const descCard = ref<HTMLElement>();
const longStr = ref<boolean>(false);
const longDesc = ref<boolean>(false);
const isShowModelPromo = ref<boolean>(false);
const debugPanel = computed(() => globalStore.debugPanel);
const description = computed(() => props.data?.description || '');
const onResize = () => {
  if (
    descCard.value &&
    props?.data?.name &&
    descCard.value?.scrollHeight &&
    descCard.value?.offsetHeight
  )
    longDesc.value =
      (description.value.length > 150 || props.data.name.length > 150) &&
      descCard.value.scrollHeight > descCard.value.offsetHeight;
};

const { parsedDiscount, isPercent, isRuble } = useParseDiscount(
  props.data.discount
);
const advertising = `Реклама, ${
  props.data?.shop_info?.site?.split('//')[1] || ''
}`;

function openModal() {
  isShowModelPromo.value = true;
}

onMounted(() => {
  if (titleCard.value) longStr.value = titleCard.value?.offsetHeight > 20;
  onResize();
  window.addEventListener('resize', onResize);
});

onUnmounted(() => window.removeEventListener('resize', onResize));

watch(
  () => titleCard.value?.offsetHeight,
  (newHeight, _) => {
    if (newHeight) longStr.value = +newHeight > 20;
  }
);
</script>
<style scoped lang="scss" src="./promocode-cardScss.scss" />
